import React, { useLayoutEffect, useRef } from "react";
import HeaderStatisticsItems from "./HeaderStatisticsItem";

function titleContentHeight(slot) {
    const text = slot.querySelector("p");
    return text ? text.offsetHeight : slot.offsetHeight;
}

function alignTitleSlots(root) {
    const slots = Array.from(root.querySelectorAll("[data-stat-title]"));
    if (slots.length === 0) {
        return;
    }

    const rows = new Map();
    slots.forEach((slot) => {
        const top = Math.round(slot.getBoundingClientRect().top);
        const group = rows.get(top);
        if (group) {
            group.push(slot);
        } else {
            rows.set(top, [slot]);
        }
    });

    rows.forEach((group) => {
        const maxHeight = Math.max(...group.map(titleContentHeight));
        const next = `${maxHeight}px`;
        group.forEach((slot) => {
            if (slot.style.minHeight !== next) {
                slot.style.minHeight = next;
            }
        });
    });
}

function HeaderStatisticsSection({ items = [], className }) {
    const gridRef = useRef(null);
    const titleKey = items.map((item) => item.title).join("|");

    useLayoutEffect(() => {
        const root = gridRef.current;
        if (!root) {
            return;
        }

        const run = () => {
            alignTitleSlots(root);
        };

        run();

        const observer = new ResizeObserver(run);
        observer.observe(root);

        return () => {
            observer.disconnect();
        };
    }, [titleKey, items.length]);

    return (
        <div
            ref={gridRef}
            className={className || "min-w-full p-3 grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"}
        >
            {items.map((item, i) => {
                const iconTintIndex = typeof item.iconTintIndex === "number" ? item.iconTintIndex : i;
                return (
                    <HeaderStatisticsItems
                        icon={item.icon}
                        title={item.title}
                        titleHint={item.titleHint}
                        value={item.value}
                        key={i}
                        iconTintIndex={iconTintIndex}
                        tone={item.tone}
                        barPercent={item.barPercent}
                    />
                );
            })}
        </div>
    );
}

export default HeaderStatisticsSection;
